import { CLEAN_SALE_ORDER_DETAIL, CLEAN_SALE_ORDER_DETAIL_ERROR } from '_models/redux/types';

export const cleanSaleOrderDetailAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_SALE_ORDER_DETAIL,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_SALE_ORDER_DETAIL_ERROR,
    });
  }
};
